import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { finalize, map, Observable, shareReplay, tap } from 'rxjs';

import { environment } from '../../environments/environment';
import { CookieService } from './cookie.service';

interface TokenResponse {
  token: string;
}

@Injectable({ providedIn: 'root' })
export class IamService {
  private readonly cookieService = inject(CookieService);
  private readonly http = new HttpClient(inject(HttpBackend));
  private tokenRequest?: Observable<string>;

  getToken(): Observable<string> {
    if (!this.tokenRequest) {
      this.tokenRequest = this.http
        .get<TokenResponse>(`${environment.baseUrl}/auth`, {
          params: { apikey: environment.apiKey },
        })
        .pipe(
          map(({ token }) => token),
          tap((token) => this.cookieService.write('iamToken', token, 3000 / 86_400)),
          finalize(() => {
            this.tokenRequest = undefined;
          }),
          shareReplay({ bufferSize: 1, refCount: false }),
        );
    }

    return this.tokenRequest;
  }
}